"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TRANSACTIONS_MAPPING = {
    prefix: 'transactions',
    getResidentTransactions: {
        path: '/getResidentTransactions',
        parameter: '/:residentId'
    },
    getTransactionLineItems: {
        path: '/getTransactionsLineItems',
        parameter: '/:transactionId'
    },
    getResidentTransactionsLineItems: {
        path: '/getResidentTransactionsLineItems',
        parameter: '/:residentId'
    }
};
